/**
 * Use Case: Atualizar Usuário
 * Orquestra a atualização de um usuário existente
 */

import { IUserRepository } from '../../../domain/repositories/IUserRepository';
import { User } from '../../../domain/entities/User';
import { NotFoundError } from '../../../core/errors/DomainErrors';

export interface UpdateUserDTO {
    id: string;
    name?: string;
    email?: string;
    role?: 'admin' | 'agent';
}

export class UpdateUserUseCase {
    constructor(private readonly userRepository: IUserRepository) { }

    async execute(dto: UpdateUserDTO): Promise<void> {
        // Busca usuário existente
        const existingUser = await this.userRepository.findById(dto.id);

        if (!existingUser) {
            throw new NotFoundError('Usuário', dto.id);
        }

        // Cria nova instância com dados atualizados
        // Como User tem campos readonly, precisamos criar uma nova instância
        const updatedUser = new User(
            existingUser.id,
            dto.name ?? existingUser.name,
            dto.email ?? existingUser.email,
            dto.role ?? existingUser.role,
            existingUser.lastAccess
        );

        // Persiste alterações
        await this.userRepository.save(updatedUser);
    }
}
